import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Slider from "react-slick";

import {
    Wrapper,
    SliderWrapper,
    StyledImg,
    Description,
    Details,
    PageBottomLinearBg,
    PageTopLinearBg,
    DetailsContainer,
    Title,
} from "./styles";

const slideSettings = {
    arrows: false,
    dots: false,
    infinite: true,
    fade: true,
    speed: 1500,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
};

const HeroVideo = () => {
    const image = useStaticQuery(graphql`
        fragment ImageFragment on File {
            childImageSharp {
                fluid(
                    maxWidth: 3000
                    maxHeight: 1500
                    grayscale: false
                    quality: 100
                ) {
                    ...GatsbyImageSharpFluid_withWebp
                }
            }
        }
        fragment HeroFragment on File {
            childImageSharp {
                fluid(
                    maxWidth: 3000
                    maxHeight: 1200
                    grayscale: false
                    quality: 100
                ) {
                    ...GatsbyImageSharpFluid_withWebp
                }
            }
        }
        query {
            thumbnail_2: file(relativePath: { eq: "KOFFIA_2025_Done_1.jpg" }) {
                ...HeroFragment
            }
            thumbnail_3: file(relativePath: { eq: "KOFFIA_2026_Done_2.jpg" }) {
                ...HeroFragment
            }
            thumbnail_4: file(relativePath: { eq: "KOFFIA_2026_Done_3.jpg" }) {
                ...HeroFragment
            }
            thumbnail_5: file(relativePath: { eq: "KOFFIA_2026_Done_4.jpg" }) {
                ...HeroFragment
            }
            thumbnail_6: file(relativePath: { eq: "KOFFIA_2026_Done_5.jpg" }) {
                ...HeroFragment
            }
        }
    `);

    return (
        <Wrapper>
            <SliderWrapper>
                <Slider {...slideSettings}>
                    <StyledImg
                        fluid={image.thumbnail_2.childImageSharp.fluid}
                    />
                    <StyledImg
                        fluid={image.thumbnail_3.childImageSharp.fluid}
                    />
                    <StyledImg
                        fluid={image.thumbnail_4.childImageSharp.fluid}
                    />
                    <StyledImg
                        fluid={image.thumbnail_5.childImageSharp.fluid}
                    />
                    <StyledImg
                        fluid={image.thumbnail_6.childImageSharp.fluid}
                    />
                </Slider>
            </SliderWrapper>
            <Description>
                <PageTopLinearBg />
                <PageBottomLinearBg />
                <DetailsContainer>
                    <Title>
                        Thank you to everyone who joined and supported the 17th
                        Korean Film Festival in Australia!
                    </Title>
                    <br />
                    <Details>
                        We’re grateful to everyone who made this year’s festival
                        a success and look forward to welcoming you back in
                        2027!
                    </Details>
                </DetailsContainer>
            </Description>
        </Wrapper>
    );
};

export default HeroVideo;
